<template>
  <v-container class="pa-0">
    <v-row>
      <v-col class="text-right pa-0" cols="12">
        <v-btn color="primary" text @click="downloadList" :disabled="!list.length">
          <v-icon small class="pr-2">fa-download</v-icon>
          Exportar
        </v-btn>
      </v-col>
      <v-col class="pa-0" cols="12">
        <v-data-table
          :headers="headers"
          :items="list"
          hide-default-footer
          dense
        >
          <template v-slot:item.origem="{item}" >
            <v-icon :color="status[item.origem].color" size="13px" class="pr-1">fas fa-circle</v-icon >
            {{status[item.origem].text}}
          </template>
          <template v-slot:item.valor_glosado="{item}" >
            <b>R$ {{item.valor_glosado | formatPrice}}</b>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      page: 1,
      newList: [{
        "origem": "autorizacoes",
        "cod": "9918",
        "descricao": "Cobrança de procedimento que exige guia autorizada.",
        "valor":  598.87
      }],
       headers: [
        { text: "Motivo de glosa", value: "descricao_motivo_glosa", sortable: false },
        { text: "Código", value: "motivo_glosa", align: 'center', sortable: false },
        { text: "Valor glosado", value: "valor_glosado", align: 'right',sortable: true },

      ],
      status:{
        'autorizacoes': {text: 'Autorizações', color:'#32b88b'},
        'beneficiarios': {text: 'Beneficiarios', color:'#b2b842'},
        'divergencia_de_valores': {text: 'Divergencia de valores', color:'#fc9d0a'},
        'processo_de_cobranca': {text: 'Processo de cobrança', color:'#fc5f17'},
        'servico_nao_contratado': {text: 'Serviço não contratado', color:'#d0021b'},
        'outros': {text: 'Outros', color:'#4a4a4a'},
        'demais': {text: 'Demais origens', color:'#979797'},
        'demais_motivos': {text: 'Somatório dos demais motivos', color:'#979797'}
      }
    };
  },
  props: {
    dados_pgto: Object,
    list: Array
  },
  computed: {
    ...mapState({
      operadoras: (state) => state.permissions.operadoras
    }),
  },
  mounted() {
    this.formatList()
  },
  methods: {
    ...mapActions('autorizador', [
      "setFilter"
    ]),
    formatList() {
      this.newList = this.list.map(item => {
        let total = item.total_solicitacoes
        item.operadora = this.operadoras[item.operadora_id]
        item.porcentAutorizada = total > 0 ? (item.autorizadas / total * 100).toFixed() : (0).toFixed()
        item.porcentAutorizadaParcialmente = total>0 ? (item.autorizadas_parcialmente / total * 100).toFixed() : (0).toFixed()
        item.porcentEmAnalise = total>0 ? (item.em_analise / total * 100).toFixed() : (0).toFixed()
        item.porcentAguardandoDados = total>0 ? (item.aguardando_dados_prestador / total * 100).toFixed() : (0).toFixed()
        item.porcentNegada = total>0 ? (item.negadas / total * 100).toFixed() : (0).toFixed()
        item.porcentCancelada = total>0 ? (item.canceladas / total * 100).toFixed() : (0).toFixed()
        item.porcentSemResposta = total>0 ? (item.sem_resposta / total * 100).toFixed() : (0).toFixed()
        return item
      })
    },
    convertToCSV(jsonList){
       let colunasDictionary ={
        descricao_motivo_glosa: "Motivo de glosa",
        motivo_glosa: "Código",
        valor_glosado: "Valor Glosado"
      }

      let headerKeys = Object.keys(colunasDictionary)
      let header = headerKeys.map(col=>colunasDictionary[col])

      let body = jsonList.reduce((str, line) => {
        let newLine = ''
        headerKeys.forEach( key => {
            if( newLine != '') { newLine += ';'}
            newLine += line[key]
        })
        return str += newLine + '\r\n';
      }, '')
      return "\ufeff" + header.join(';') + '\r\n' + body
    },
    downloadList() {
      let date = this.dados_pgto.data_pagamento.split('T')[0]
      let fileData = this.convertToCSV(this.list)
      let fileBlob = new Blob([fileData], { type: 'text/csv; charset=UTF-8;' })
      let downloadUrl = (window.URL || window.webkitURL).createObjectURL(fileBlob)
      let a = document.createElement("a")
      a.href = downloadUrl
      a.download = `resumo_das_glosas_${date}_${this.dados_pgto.prest_nome}_${this.dados_pgto.oper_nome}.csv`
      document.body.appendChild(a)
      a.click();
      URL.revokeObjectURL(downloadUrl)
    }
  }
};
</script>

<style>
.porcentagem {
  border-radius: 12px;
  width: 100%;
  padding: 2px;
}
.text-porcent {
  font-size: 10px;
  color: white;
  margin: 1px 0 0 !important;
}
.card-porcent {
  width: 80px;
}
.font-list{
  font-family: "system-ui";
}
</style>
